'use client';
import { Toaster } from 'sonner';

export default function ToasterProvider() {
  return (
    <>
      {/* aria-live region for toast announcements — WCAG 4.1.3 */}
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
        id="toast-announcer"
      />
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          // Ensure toasts are accessible with sufficient display time
          duration: 5000,
        }}
      />
    </>
  );
}
